<template>
    <div>
      <el-dialog v-loading="loading" :title="type == 'create'||type == 'anewcreate' ? '提交追差申请' : '追差申请详情'" :visible.sync="visible" :close-on-click-modal="false" width="900px">
        <div class="box">
          <el-row>
            <el-col :span="13">
              <div class="title">订单信息</div>
              <div class="info-item">
                <span class="mr-30">{{ info.phoneName }}</span>
                <span>IMEI：{{ info.imei }}</span>
                <el-link type="primary" :underline="false" class="ml-10" @click="$refs['functionDia'].open(row)">查看功能情况</el-link>
              </div>
              <div class="info-item">
                <span class="mr-30">回收商实报价：{{info.quotePrice}} </span> 
                <span>外部成交价：{{info.chxPrice}}</span> 
              </div>
            </el-col>
            <!-- <el-col :span="11">
              <div class="title">收款信息</div>
              <div class="info-item">收款人真实姓名：{{ info.payeeName }}</div>
              <div class="info-item">收款人支付宝账户：{{ info.payeeAlipayAccount }}</div>
            </el-col> -->
            <el-col :span="24" style="margin-top:15px">
              <div class="title">平台追差内容</div>
              <div class="info-item">申请回收商：{{ info.applyMerchantName }}</div>
              <div class="info-item">
                <span class="mr-30">申请金额：{{ info.arguePrice }}元 </span>
                <span class="mr-30">初审通过金额：{{ info.auditPrice }}元</span>
                <span class="mr-30">复核打款金额：{{ info.rePayPrice || '--' }}元</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="box gray">
          <div class="title">追差提交信息</div>
          <el-form ref="formRef" :model="formData" :rules="formRule" :disabled="type == 'detail'">
            <!-- <el-form-item label="售后方式：" prop="argueType">
              <el-radio-group v-model="formData.argueType">
                <el-radio :label="0">补差</el-radio>
                <el-radio :label="1">退货退款</el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item label="追差金额：" prop="arguePrice">
              <el-input v-model="formData.arguePrice" style="width:100px" />
              元
            </el-form-item>
            <el-form-item label="追差原因：" prop="argueNote">
              <el-input v-model="formData.argueNote" type="textarea" :rows="3" />
            </el-form-item>
            <div >
                    <div>追差凭证：</div>
            <div style="padding: 15px;">
              <div style="margin-bottom: 5px;">追差视频<span :style="{color: videoMust?'red':''}">（{{videoMust?'该渠道必传':'非必传'}}）</span></div>
               <!-- <UploadImgOrVideo :accept="'.mp4'" v-model="videos" ref="imagesRef" /> -->
             <videoScreenshot :videos="videos" @getServerVideoUrls="getServerVideoUrls" @getServerImageUrl="getServerImageUrl" :disabled="disabled">
              </videoScreenshot>
            </div>
                  <div style="padding: 15px;">
              <div style="margin-bottom: 5px;">追差照片<span :style="{color: imageMust?'red':''}">（{{imageMust?'该渠道必传':'非必传'}}）</span></div>
                  <div style="width: 100%;overflow-x: scroll;">
   <PasteUploadDia @confirm="(v) => formData.images.push(v)">
                     <template slot-scope="scope">
                       <div style="display: flex;">
                      <div v-for="(item, index) in formData.images" :key="item" style="display: flex;">
                        <i class="el-icon-circle-close" style="margin: 0 10px;" @click="formData.images.splice(index, 1)" />
                        <el-image style="height: 130px;width: 130px;margin-right: 10px;" :src="item" :preview-src-list="[item]" />
                      </div>
                      <div class="upload_img" style="height: 130px;width: 130px;display: flex;justify-content: center;align-items: center;flex-shrink: 0;" v-if="formData.images" @click="scope.open()">
                        <i class="el-icon-plus"></i>
                      </div>
                    </div>
                     </template>
                 
                </PasteUploadDia>
                  </div>
               
            </div>
            </div>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="close()">取消</el-button>
          <el-button v-if="type !== 'detail'" type="primary" @click.native="confirm">确定提交</el-button>
        </span>
      </el-dialog>
      <FunctionDia ref="functionDia" />
    </div>
  </template>
  
  <script>
  import _api from "@/utils/request";
  import UploadImgOrVideo from './UploadImgOrVideo.vue';
  import FunctionDia from './FunctionDia.vue';
  import PasteUploadDia from './PasteUploadDia.vue';
import videoScreenshot from '../caiHuoXiaReview/componets/videoScreenshot.vue';

  export default {
    components: { videoScreenshot, FunctionDia,PasteUploadDia },
    name: "ExternalApplication",
    data() {
      const arguePriceVaild = (rule, value, callback) => {
        const number = Number(value)
        if (number > this.info.chxPrice) callback(new Error('不得高于外部成交金额'))
        callback()
      }
      return {
        visible: false,
        row: {},
        info: {},
        loading: false,
        type: 'create', // create detail
        formData: {
          // argueType: '',
          arguePrice: '',
          argueNote: '',
          images: []
        },
        formRule: {
          // argueType: [{ required: true, message: '请选择售后方式', trigger: 'change' }],
          arguePrice: [
            { required: true, message: '请输入追差金额', trigger: 'change' },
            { validator: arguePriceVaild, trigger: 'change' }
          ],
          argueNote: [{ required: true, message: '请输入追责原因', trigger: 'change' }],
          images: [{ required: true, message: '请上传图片', trigger: 'change' }],
        },
        videos:[],
        videoMust:false,
        imageMust:false,
              disabled: false

      };
    },
    methods: {
                   getServerVideoUrls(data) {
      this.videos = data
    },
    getServerImageUrl(data) {
      this.formData.images = [...this.formData.images, data]
      
    },
      open(row, type = 'create') {
        this.row = row
        const {outType,orderNo} = row
         _api.getFlagByOutType({
          outType,orderNo
        }).then(res => {
          const {data} = res
          if(data == '05'){
            this.videoMust = true
            this.imageMust = true
          }else if (data == '06'){
            this.videoMust = true
            this.imageMust = false
          }else if (data == '07'){
            this.videoMust = false
            this.imageMust = true
          }else if (data == '08'){
            this.videoMust = false
            this.imageMust = false
          }
        }).finally(() => {
        })
        this.type = type
        this.formData = {
          // argueType: '',
          arguePrice: '',
          argueNote: '',
          images: []
        }
        // this.$refs['uploadImgOrVideo']?.init()
        this.getArgueDetail()
        this.$nextTick(() => {
          this.$refs['formRef']?.clearValidate()
          this.visible = true
        })
      },
      getArgueDetail() {
        this.loading = true
        const { argueNo, subArgueNo } = this.row
        _api.actionAprgdetail({
          argueNo: argueNo == '--' ? undefined : argueNo,
          subArgueNo: subArgueNo == '--' ? undefined : subArgueNo
        }).then(res => {
          this.info = res.data
          const { arguePriceHonor, argueNote, images, items, applyNote, arguePrice } = res.data
          if (this.type === 'create') {
           const { videos, others } = this.groupFilesByType(images);
                               this.disabled = false

            this.videos = videos
            this.formData.images = others
            this.formData.arguePrice = arguePrice
            this.formData.argueNote = [...(items||[]), applyNote].filter(v => v).join('，')
          }
          if(this.type === 'anewcreate'){
           const { videos, others } = this.groupFilesByType(images);
          this.disabled = false

            this.videos = videos
            this.formData.images = others
          this.formData.arguePrice = arguePrice
          this.formData.argueNote = argueNote?argueNote:''
        }
          if (this.type === 'detail'){
           const { videos, others } = this.groupFilesByType(images);
            this.videos = videos
          this.formData = { arguePrice: arguePriceHonor, argueNote, images:others }
          this.disabled = true

          }
          
        }).finally(() => {
          this.loading = false
        })
      },

groupFilesByType(files) {
  return files.reduce((groups, file) => {
    // 检查文件是否以.mp4结尾（不区分大小写）
    if (/\.mp4$/i.test(file)) {
      groups.videos.push(file);
    } else {
      groups.others.push(file);
    }
    return groups;
  }, { videos: [], others: [] }); // 初始值：两个空数组
},

      close() {
        this.visible = false
        if(this.row.comeplat){
        window.location.href = `/difference/platformReview`;
      }

      },
      confirm() {
        this.$refs['formRef'].validate((vaild) => {
          if (vaild) {
            console.log('this.videos',this.videos);
            console.log('this.formData.images',this.formData.images);
            
            if(this.videos.length == 0 && this.videoMust){
                        this.$message({
                message: '请上传视频再提交',
                type: 'warning'
              });
              return
            }
             if(this.formData.images.length == 0  && this.imageMust){
                        this.$message({
                message: '请上传图片再提交',
                type: 'warning'
              });
              return
            }
            _api.actionAprgeneral({
              ...this.formData,
              images:[...this.formData.images,...this.videos],
              argueNo: this.row.argueNo
            }).then(() => {
              this.$message.success('操作成功')
              this.close()
              this.$emit('confirm')
            })
          }
        })
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .box{
    padding: 10px;
    &.gray {
      background: rgb(245, 246, 250);
    }
  }
  .title{
    font-weight: bold;
    margin-bottom: 10px;
  }
  .info-item{
    margin-bottom: 8px;
    display: flex;
  }
  .mr-30{
    margin-right: 30px;
  }
  .ml-10{
    margin-left: 10px;
  }
  </style>